import { render, staticRenderFns } from "./ManagePanel.vue?vue&type=template&id=b961bb88&scoped=true"
import script from "./ManagePanel.vue?vue&type=script&lang=js"
export * from "./ManagePanel.vue?vue&type=script&lang=js"
import style0 from "./ManagePanel.vue?vue&type=style&index=0&id=b961bb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b961bb88",
  null
  
)

export default component.exports